module.exports = __webpack_public_path__ + "videos/splash-2.1ca1590.mp4";